module.exports = __webpack_public_path__ + "img/logo.8252c488.png";